const pageTitle = {
  'Google Merchant Center': 'Google Merchant Center - Cài đặt Shopping Ads',
};

export default pageTitle;
